import { render, staticRenderFns } from "./ClinicalGuides.vue?vue&type=template&id=1177218b"
import script from "./ClinicalGuides.vue?vue&type=script&lang=js"
export * from "./ClinicalGuides.vue?vue&type=script&lang=js"
import style0 from "./ClinicalGuides.vue?vue&type=style&index=0&id=1177218b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports